// extracted by mini-css-extract-plugin
export default {"wrapper":"q2-z","play":"r2-z"};